import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

const FixedBarStatus = ({
  className, status, name, count, onClick, selected, style,
}) => {
  const classNames = [
    'uc-tab-status',
  ];
  if (className) {
    classNames.push(className);
  }
  if (selected) {
    classNames.push('selected');
  }
  const handleOnClick = (event) => {
    event.preventDefault();
    if (onClick) {
      onClick(status);
    }
  };
  return (
    <Grid.Column
      className={classNames.join(' ')}
      onClick={handleOnClick}
      style={style}
    >
      <p>{count}</p>
      {name}
    </Grid.Column>
  );
};

FixedBarStatus.contextTypes = {
  store: PropTypes.object,
};

FixedBarStatus.propTypes = {
  className: PropTypes.string,
  status: PropTypes.string,
  name: PropTypes.string,
  count: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  style: PropTypes.shape({
    minWidth: PropTypes.string,
    maxWidth: PropTypes.string,
  }),
};

export default FixedBarStatus;



// WEBPACK FOOTER //
// ./src/components/UpdatedComponents/UCFixedBarStatus.jsx